import React from 'react';
import type { BirdEyeDropTarget } from '../../bird-eye/boardTypes';
import type { BirdEyeOperatory } from '../../bird-eye/types';
import { cn } from '../../lib/cn';
import { BirdEyePatientCard } from './BirdEyePatientCard';
import { useBirdEyeDnd } from './BirdEyeDndContext';

export interface BirdEyeOperatoryBoxProps {
  operatory: BirdEyeOperatory;
  opIndex: number;
}

export function BirdEyeOperatoryBox({ operatory: op, opIndex }: BirdEyeOperatoryBoxProps) {
  const dnd = useBirdEyeDnd();
  const dropTarget: BirdEyeDropTarget = { type: 'operatory', index: opIndex };
  const dropHandlers = dnd.bindDropZone(dropTarget);
  const dropActive = dnd.isDropActive(dropTarget);
  if (!op.seated) {
    return (
      <div
        {...dropHandlers}
        className={cn(
          'flex min-h-[92px] flex-col items-center justify-center gap-1 rounded-xl border-[1.5px] border-dashed border-[var(--cream-shadow)] transition-[outline,background] duration-150',
          dropActive && 'be-drop-active',
        )}
        style={{
          background:
            'repeating-linear-gradient(45deg, var(--cream-0) 0 7px, transparent 7px 14px)',
        }}
      >
        <span className="font-[var(--font-mono)] text-[10.5px] font-semibold uppercase tracking-[0.08em] text-[var(--ink-4)]">
          {op.room}
        </span>
        <span className="text-[11.5px] text-[var(--ink-4)]">Open</span>
      </div>
    );
  }

  return (
    <div {...dropHandlers} className={cn('rounded-xl transition-[outline] duration-150', dropActive && 'be-drop-active')}>
      <div className="mb-[5px] font-[var(--font-mono)] text-[9.5px] font-bold uppercase tracking-[0.1em] text-[var(--ink-4)]">
        {op.room}
      </div>
      <BirdEyePatientCard
        patient={op.seated}
        dragSource={{ type: 'operatory', index: opIndex }}
      />
    </div>
  );
}
